import { variables } from 'src/Tenants';

export type RoleGroup = 'property-scoped' | 'unit-scoped';

export interface RoleRegistryEntry {
  id: string;
  group: RoleGroup;
  displayName: string;
  leaveWarning?: string;
}

// Single source of truth for assignable roles. To re-scope a role, move its `group`. To change per-role messaging, edit `leaveWarning`. Group-level messaging lives in roleRegistryHelpers.
export const ROLE_REGISTRY = [
  {
    id: 'Property Developer',
    group: 'property-scoped',
    displayName: variables.propertyDeveloper,
  },
  {
    id: 'Service Manager',
    group: 'property-scoped',
    displayName: 'Service Manager',
  },
  {
    id: 'Service Provider',
    group: 'property-scoped',
    displayName: 'Service Provider',
  },
  {
    id: 'Vendor',
    group: 'property-scoped',
    displayName: 'Vendor',
  },
  {
    id: 'Home Owner',
    group: 'unit-scoped',
    displayName: variables.homeOwner,
    leaveWarning:
      'Primary contact and designated flags on all units will be cleared.',
  },
  {
    id: 'Realtor',
    group: 'unit-scoped',
    displayName: 'Realtor',
  },
  {
    id: 'Occupant',
    group: 'unit-scoped',
    displayName: 'Occupant',
  },
  {
    id: 'Strata Manager',
    group: 'unit-scoped',
    displayName: variables.strataManager,
  },
] as const satisfies readonly RoleRegistryEntry[];

export type AssignableRole = (typeof ROLE_REGISTRY)[number]['id'];
